import moment from "moment";

export const usd = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

export const removeSpecialCharacters = (string) => {
  return string.replace(/[`~!@#$%^&*()_|+\-=?;:'",\s<>\{\}\[\]\\\/]/gi, "");
};
export const removeNonNumericCharacters = (string) => {
  return string.replace(/[^0-9.]/gi, "");
};
// Remove the timezone portion of the dates returned from the API so moment doesn't
// get confused
export const formatDate = (date) => {
  if (date != null) {
    return moment(date.split("T")[0]).format("MMM Do, YYYY");
  } else {
    return moment(new Date()).format("MMM Do, YYYY");
  }
};

// this magical regex was taken from the react number format npm package that we're using for input field formatting
export const addThousandsSeparators = (value) => {
  value = Number(value).toFixed(2);
  return value.substring(0, value.length).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + ",");
};

export const listOfStates = [
  "",
  "AK - Alaska",
  "AL - Alabama",
  "AR - Arkansas",
  "AS - American Samoa",
  "AZ - Arizona",
  "CA - California",
  "CO - Colorado",
  "CT - Connecticut",
  "DC - District of Columbia",
  "DE - Delaware",
  "FL - Florida",
  "GA - Georgia",
  "GU - Guam",
  "HI - Hawaii",
  "IA - Iowa",
  "ID - Idaho",
  "IL - Illinois",
  "IN - Indiana",
  "KS - Kansas",
  "KY - Kentucky",
  "LA - Louisiana",
  "MA - Massachusetts",
  "MD - Maryland",
  "ME - Maine",
  "MI - Michigan",
  "MN - Minnesota",
  "MO - Missouri",
  "MS - Mississippi",
  "MT - Montana",
  "NC - North Carolina",
  "ND - North Dakota",
  "NE - Nebraska",
  "NH - New Hampshire",
  "NJ - New Jersey",
  "NM - New Mexico",
  "NV - Nevada",
  "NY - New York",
  "OH - Ohio",
  "OK - Oklahoma",
  "OR - Oregon",
  "PA - Pennsylvania",
  "PR - Puerto Rico",
  "RI - Rhode Island",
  "SC - South Carolina",
  "SD - South Dakota",
  "TN - Tennessee",
  "TX - Texas",
  "UT - Utah",
  "VA - Virginia",
  "VI - Virgin Islands",
  "VT - Vermont",
  "WA - Washington",
  "WI - Wisconsin",
  "WV - West Virginia",
  "WY - Wyoming",
];

export const constructDebitRequest = (values, combinedFeeAmount, skipPaymentMethod) => {
  let debitRequest;
  if (values && skipPaymentMethod === "Debit Card") {
    const paymentDetails = Object.assign({}, values);

    // Attach amount value as a string because that's what constructDebitEpxRequest expects
    paymentDetails.amount = `${combinedFeeAmount}`;

    debitRequest = constructDebitEpxRequest(paymentDetails);
  }

  return debitRequest;
};

export const constructDebitEpxRequest = (formValues) => {
  // Create copy of form values
  let paymentDetails = Object.assign({}, formValues);

  // Split out the first and last name because EPX wants them seperated for some reason
  let cardName = paymentDetails.nameOnCard.split(" ");
  paymentDetails.first_name = cardName[0];
  paymentDetails.last_name = cardName[cardName.length - 1];
  // Format amount and expiration date fields for EPX
  paymentDetails.amount = removeNonNumericCharacters(paymentDetails.amount);
  paymentDetails.exp_date = `${paymentDetails.exp_date.split("/")[1]}${
    paymentDetails.exp_date.split("/")[0]
  }`;

  return paymentDetails;
};

export const isAmountPastDueBetweenBalanceAndPayoff = (amountPastDue, payoffAmount, currentBalance) => {
  const amountPastDueBetweenPayoffAndBalance =
    amountPastDue &&
    payoffAmount &&
    currentBalance &&
    amountPastDue < payoffAmount &&
    amountPastDue > currentBalance ? true : false;

  return amountPastDueBetweenPayoffAndBalance;
};



// WEBPACK FOOTER //
// ./src/utils/utils.js